import dynamic from 'next/dynamic';

import { useUserVehicle } from './UserVehicle.hook';

import { Guide } from '../subcomponents/Guide/Guide';
import { VehicleDetails } from '../subcomponents/VehicleDetails/VehicleDetails';
import { Text } from 'components/ToolkitV2/Text/Text';
import { Button } from 'components/Toolkit/Button/Button';
import { LinkButton } from 'components/Toolkit/Button/LinkButton';

import { type UserVehicle as UserVehicleType } from '../../queries/schema/UserVehicle.schema';

import * as Styled from './UserVehicle.styled';

import { Spacer } from 'helpers/genericStyles';
import { formatValuation, formatVehicleDetails } from '../../formatting';

const RemoveUserVehicleModal = dynamic(
  import('../RemoveUserVehicleModal/RemoveUserVehicleModal').then(
    (mod) => mod.RemoveUserVehicleModal,
  ),
);

type UserVehicleProps = {
  emailResponse: boolean;
} & UserVehicleType;

const UserVehicle = (props: UserVehicleProps) => {
  const {
    valuationDate,
    valuationDetails: { vehicleDetails, expectedDealerOfferRange },
    emailResponse,
  } = props;

  const {
    updateVehicleDetails,
    openRemoveUserVehicleModal,
    openDealerEnquiryModal,
  } = useUserVehicle();

  return (
    <>
      <Text forwardedAs="h2" size="L18" weight="bold">
        How much is your car worth?
      </Text>
      <Spacer marginBottom="M24" />
      <VehicleDetails
        name={`${vehicleDetails.make} ${vehicleDetails.model} ${vehicleDetails.yearOfManufacture}`}
        details={formatVehicleDetails(vehicleDetails)}
        footer={
          <Styled.Actions>
            <LinkButton
              onClick={updateVehicleDetails}
              data-tracking="cvonadp-update-details"
              fontSize="M16"
            >
              Update details
            </LinkButton>
            <LinkButton onClick={openRemoveUserVehicleModal} fontSize="M16">
              Remove vehicle
            </LinkButton>
          </Styled.Actions>
        }
        mb="M16"
      />
      <Guide
        header="Trade-in sale guide"
        body={formatValuation(expectedDealerOfferRange)}
        footer={`Price for ${valuationDate}`}
        backgroundColor="BLUE_LIGHTER"
      />
      {emailResponse && (
        <>
          <Spacer marginBottom="M24" />
          <Button
            ofType="SECONDARY"
            onClick={openDealerEnquiryModal}
            data-tracking="cvonadp-trade-in-against-this-ad"
          >
            Trade in against this ad
          </Button>
        </>
      )}
      <RemoveUserVehicleModal />
    </>
  );
};

export { UserVehicle };
